import styled from "styled-components"

const S = {}

S.Navigation = styled.nav`
  display: flex;
  align-items: center;

  & ul {
    margin: 0 0 0 240px;
    display: flex;
    list-style-type: none;
    padding: 0;
    height: 80px;
    transition: linear 0.3s;

    & .icons-wrapper {
      display: flex;
    }

    @media (max-width: 1280px) and (orientation: landscape) {
      flex-flow: wrap;

      .icons-wrapper {
        justify-content: flex-start !important;
      }

      .phone {
        text-align: left !important;
      }
    }

    @media (max-width: 1280px) {
      background: #fff;
      position: absolute;
      top: calc(0px + 80px);
      right: -100%;
      flex-direction: column;
      height: calc(100vh - 80px) !important;
      width: 90vw;
      border-radius: 0 0 5px 35px;
      box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);

      & li {
        & a {
          font-size: 16px;
          width: 100%;
          text-align: center;
          margin: 0.8rem !important;
        }
        & .phone {
          width: 100%;
          padding: 1rem 0 !important;
        }
      }

      & .icons-wrapper {
        width: 100%;
        justify-content: center;

        & li {
          & a {
            font-size: 32px !important;
            margin: 0 0.3rem;
          }
        }
      }
    }

    & li {
      display: flex;
      align-items: center;

      & a {
        font-family: "Poppins", sans-serif;
        padding: .5rem 0;
        margin: 0 0.5rem;
        text-decoration: none;
        color: #666;
        font-size: 13px;
        font-weight: 500;
        text-transform: uppercase;
        transition: 0.3s ease;
        &:hover {
          color: #000;
        }
      }

      & .icon {
        font-size: 20px;
        padding: 1rem 0.5rem;
        margin: 0;
      }

      & .phone {
        font-size: 20px;
        padding: 1rem 2rem;
        width: 100%;
        text-align: center;
        font-size: 22px !important;
        & svg {
          margin-right: 5px;
          width: 0.875rem;
        }
      }

      & .animated {
        animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
        transform: translate3d(0, 0, 0);
        backface-visibility: hidden;
        perspective: 1000px;
      }

      & .active {
        position: relative;
        & ::before {
          content: "";
          width: 100%;
          height: 2px;
          border-radius: 8px;
          background: #999;
          position: absolute;
          bottom: 0;
          left: 0;
        }
      }

      & .menu-item {
        position: relative;
        & ::after {
          content: "";
          width: 100%;
          height: 2px;
          border-radius: 8px;
          background: #999;
          position: absolute;
          bottom: 0;
          left: 0;
          opacity: 0;
          transition: all .5s;
        }
        &:hover {
          & ::after {
            opacity: 1;
          }
        }
      }
    }
  }
  @keyframes shake {
    10%,
    90% {
      transform: translate3d(-1px, 0, 0);
    }

    20%,
    80% {
      transform: translate3d(2px, 0, 0);
    }

    30%,
    50%,
    70% {
      transform: translate3d(-4px, 0, 0);
    }

    40%,
    60% {
      transform: translate3d(4px, 0, 0);
    }
  }
`

export default S
